import script from "./Outage.vue?vue&type=script&lang=ts&setup=true"
export * from "./Outage.vue?vue&type=script&lang=ts&setup=true"

import "./Outage.vue?vue&type=style&index=0&id=68591aba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68591aba"]])

export default __exports__